export default __webpack_public_path__ + "static/media/grama-esportiva1.4445f7f8.jpg";